export const createTopbar = (element) => {
  const instance = {
    $element: null,
    expressions: null,
    currentIndex: 0,
    intervalId: null,

    init(element) {
      this.$element = jQuery(element);
      this.$expressions = this.$element.find(".js-topbar-expressions");
      this.expressions = this.$expressions.find(".js-topbar-expression");

      // Style setup for sliding animations
      this.$expressions.css({
        position: "relative",
        overflow: "hidden",
        minHeight: "2.5em",
      });
      this.expressions.css({
        position: "absolute",
        width: "100%",
        top: "100%",
        textAlign: "center",
        left: "0",
        right: "0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%", // Make expressions fill container height
      });

      // Initialize mobile rotation
      this.handleScreenSize();
      window.addEventListener("resize", () => this.handleScreenSize());
    },

    handleScreenSize() {
      const isTabletOrMobile = window.innerWidth < 1024;

      if (isTabletOrMobile) {
        // Reset positions and start rotation
        this.expressions.css({ position: "absolute", top: "100%" }).hide();
        this.startRotation();
      } else {
        this.stopRotation();
        this.expressions.stop(true, true);
        // Updated styles for desktop view to maintain centered positioning
        this.$expressions.css({
          display: "flex",
          justifyContent: "center",
        });
        this.expressions
          .css({
            position: "static",
            top: "auto",
            width: "auto", // Remove 100% width constraint
            display: "flex",
          })
          .show();
      }
    },

    startRotation() {
      this.stopRotation(); // Clear any existing interval

      // Hide all expressions first
      this.expressions.hide();

      // Show first expression with animation
      jQuery(this.expressions[0])
        .css({ top: "100%", zIndex: 1 }) // Add zIndex
        .show()
        .animate({ top: "0" }, 400);

      this.currentIndex = 0;

      this.intervalId = setInterval(() => {
        const currentExpression = jQuery(this.expressions[this.currentIndex]);
        const nextIndex = (this.currentIndex + 1) % this.expressions.length;
        const nextExpression = jQuery(this.expressions[nextIndex]);

        // Ensure proper z-index stacking
        currentExpression.css({ zIndex: 1 });
        nextExpression.css({ zIndex: 2 });

        // Position next expression below and show it
        nextExpression.css({ top: "100%" }).show();

        // Animate both simultaneously
        currentExpression.animate({ top: "-100%" }, 400, function () {
          // Hide and reset after animation
          currentExpression.hide().css({ zIndex: 0 });
        });

        nextExpression.animate({ top: "0" }, 400, () => {
          this.currentIndex = nextIndex;
        });
      }, 5000);
    },

    stopRotation() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
  };

  instance.init(element);
  return instance;
};
